<template lang="pug">
div
  v-row.mb-3(no-gutters)
    v-col(cols="5")
      .text-sm.font-medium.neutral500--text {{ $t('billed_to') }}
    v-col.pl-2
      .d-flex
        template(v-if="billingInfo")
          .text-sm.font-semibold.neutral700--text {{ billingInfo.name }}
        template(v-else)
          .text-sm.neutral700--text -
  v-row(no-gutters)
    v-col(cols="5")
      .text-sm.font-medium.neutral500--text {{ $t('billing_details') }}
    v-col.pl-2
      .text-sm.neutral700--text.mb-2(v-if="hasFullAddress") {{ getAddressInString(billingInfo) }}
      .text-sm.neutral700--text.mb-2(v-if="billingInfo && billingInfo.phone") +{{ billingInfo.phone }}
      template(v-else)
        .text-sm.neutral700--text.mb-2 -
      div.d-flex.align-center
        y-button(:label="$t('change_billing_details')" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="onChangeBillingDetails")
        template(v-if="billingInfo")
          v-spacer
          .text-xxs.underline.font-semibold.danger500--text.clickable(@click="openDeleteDialog = true") Remove
  .dialogs
    edit-billing-info-dialog(v-if="openEditBillingInfoDialog" :open.sync="openEditBillingInfoDialog" :parentBillingInfo="billingInfo" :parentPatient="patient" @updated="$emit('updated')")
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="openDeleteDialog = false" @delete="removeBillingDetails")
      .text-lg.font-medium Are you sure you want to remove billing details?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
</template>

<script>
import { mapGetters } from 'vuex'
import EditBillingInfoDialog from '@/components/clinic/dialogs/EditBillingInfoDialog.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: {
    EditBillingInfoDialog,
    DeleteConfirmationDialog
  },
  props: {
    billingInfo: {
      type: Object,
      default: null
    },
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      openEditBillingInfoDialog: false,
      openDeleteDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq'
    }),
    hasFullAddress() {
      return this.billingInfo && this.billingInfo.address_1
    },
    leadPid() {
      return this.$route.params.pid
    },
  },
  methods: {
    getAddressInString(addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
    onChangeBillingDetails() {
      this.openEditBillingInfoDialog = true
    },
    removeBillingDetails() {
      this.isLoading = true
      const endpoint = `/addresses/${this.billingInfo.id}`
      this.$axios.delete(endpoint)
        .then(() => {
          this.$emit('updated')
          this.updateActivityLog(endpoint, null, null, 'DELETE', this.billingInfo.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
          this.openDeleteDialog = false
        })
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      const data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'billing_info',
        activity: `Delete billing info (lead pid: ${this.leadPid})`,
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data).catch(() => {})
    }
  },
}
</script>

<style lang="scss" scoped>
</style>